import { CLINICAL_FORM_GENERAL } from './clinicalFormTemplates';

export const GENERAL_INTAKE_SCHEMA_VERSION = 1;

export function emptyGeneralIntake(header = {}) {
  return {
    form_template: CLINICAL_FORM_GENERAL,
    schema_version: GENERAL_INTAKE_SCHEMA_VERSION,
    header: {
      folio: '',
      form_date: new Date().toISOString().slice(0, 10),
      ...header,
    },
    edad: '',
    sex: '',
    medical_history: '',
    family_history: '',
    allergies: '',
    medications: '',
    chief_complaint: '',
    current_illness: '',
    physical_exam: '',
    diagnosis: '',
    treatment_plan: '',
    photo_consent: false,
    treatment_consent: false,
    consent_name: '',
  };
}

export function mergeGeneralIntake(saved) {
  const base = emptyGeneralIntake();
  if (!saved || typeof saved !== 'object') return base;
  return {
    ...base,
    ...saved,
    form_template: CLINICAL_FORM_GENERAL,
    schema_version: GENERAL_INTAKE_SCHEMA_VERSION,
    header: { ...base.header, ...(saved.header || {}) },
    edad: String(saved.edad ?? '').trim(),
    sex: String(saved.sex ?? '').trim(),
    medical_history: String(saved.medical_history ?? '').trim(),
    family_history: String(saved.family_history ?? '').trim(),
    allergies: String(saved.allergies ?? '').trim(),
    medications: String(saved.medications ?? '').trim(),
    chief_complaint: String(saved.chief_complaint ?? '').trim(),
    current_illness: String(saved.current_illness ?? '').trim(),
    physical_exam: String(saved.physical_exam ?? '').trim(),
    diagnosis: String(saved.diagnosis ?? '').trim(),
    treatment_plan: String(saved.treatment_plan ?? '').trim(),
    photo_consent: Boolean(saved.photo_consent),
    treatment_consent: Boolean(saved.treatment_consent),
    consent_name: String(saved.consent_name ?? '').trim(),
  };
}
